import React from 'react';
import { DConfirmationModal } from '../../../../../dum';
import { useDeleteEmployeeMutation } from '../../../../../../services';

interface IDeleteEmployeeProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    employeeId: number | null;
}

export function SDeleteEmployeeDialog({
    open,
    setOpen,
    employeeId,
}: IDeleteEmployeeProps) {
    const [deleteMutation] = useDeleteEmployeeMutation();

    return (
        <DConfirmationModal
            open={open}
            setOpen={setOpen}
            callback={async () => {
                if (employeeId) {
                    try {
                        await deleteMutation({
                            variables: {
                                EmployeeId: employeeId,
                            },
                        });
                        setOpen(false);
                    } catch (e) {
                        console.error(e);
                    }
                }
            }}
        />
    );
}
